import * as React from 'react';
import * as loadingActions from '../../components/loading/actions';
import {AlertDialog} from '../../components/alert-dialog/views';
import {Loading} from '../../components/loading/views';
import {dispatch} from '../../core';
import {connect} from 'react-redux';
import * as a from './actions';
import * as s from './selectors';
import './reducers';

function getCurrentPosition() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            function(position) {
                const coords = position.coords;
                resolve([coords.latitude, coords.longitude]);
            },
            function(error) {
                reject(error);
            }
        );
    });
}

function onFind({id, autocompleteInputId}) {
    const loadingNs = `findMe.${id}`;
    const loadingId = 'loading';

    dispatch(loadingActions.show(loadingNs, loadingId));
    getCurrentPosition()
        .then(([lat, lng]) => {
            const autocompleteInputSelector = `#${autocompleteInputId}`;
            $(autocompleteInputSelector)
                .parent('.shippable-autocomplete')
                .shippableAutoComplete('geo', {
                    longitude: lng,
                    latitude: lat,
                });
            dispatch(loadingActions.hide(loadingNs, loadingId));
        })
        .catch(() => {
            dispatch(a.showLocationBlocked({id}));
            dispatch(loadingActions.hide(loadingNs, loadingId));
        });
}

function LocationBlockedAlertBody({title}) {
    return (
        <p>
            <strong>{title}</strong>
        </p>
    );
}

const LocationBlockedDialog = connect(
    (state, {id}) => ({
        showLocationBlockedDialog: s.showLocationBlockedDialog(state, id),
    }),
    (dispatch, {id}) => ({confirm: () => dispatch(a.hideLocationBlocked({id}))})
)(({texts, showLocationBlockedDialog, confirm}) => {
    return showLocationBlockedDialog ? (
        <AlertDialog
            message={
                <LocationBlockedAlertBody title={texts.location_blocked_text} />
            }
            confirmLabel={texts.location_blocked_confirm}
            onConfirm={confirm}
        />
    ) : null;
});

export const FindMe = connect(
    undefined,
    (dispatch, {id, autocompleteInputId}) => ({
        onClick: () => onFind({id, autocompleteInputId}),
    })
)(({id, onClick, texts}) => {
    const loadingNs = `findMe.${id}`;

    return (
        <React.Fragment>
            <Loading ns={loadingNs} id="loading" />
            <LocationBlockedDialog texts={texts} id={id} />
            <button
                type="button"
                onClick={onClick}
                className="btn btn--findme"
            >
            </button>
        </React.Fragment>
    );
});
